"use client";
import React from "react";
import ScriptPaymentSummary from "../../Script/views/ScriptPaymentSummary.jsx";

export default function AmmendScriptPaymentSummary() {
  return <ScriptPaymentSummary />;
}
